import { ArrowRight } from "lucide-react";
import { PlacementKey, useMonetization } from "@/hooks/useMonetization";

// Affiliate CTA's temporarily disabled until traffic threshold is reached
const AFFILIATE_CTA_ENABLED = false;

interface Props {
  placement: PlacementKey;
  category?: string;
  /** Fallback content when no DB block exists for this placement. */
  fallback?: { title: string; description: string; buttonText?: string };
}

export const CtaBlock = ({ placement, category, fallback }: Props) => {
  if (!AFFILIATE_CTA_ENABLED) return null;

  const block = useMonetization(placement, category);

  if (!block && !fallback) return null;

  const title = block?.title ?? fallback?.title ?? "Vergelijk vrijblijvend offertes";
  const description =
    block?.description ??
    fallback?.description ??
    "Ontvang offertes van geverifieerde installateurs in jouw regio.";
  const buttonText = block?.button_text ?? fallback?.buttonText ?? "Vergelijk installateurs";
  const url = block?.target_url ?? "#";

  const label = block?.is_sponsored
    ? "Gesponsord"
    : block?.is_affiliate
    ? "Affiliate link"
    : "Advertentie";

  return (
    <div className="rounded-2xl border border-accent/30 bg-gradient-to-br from-accent/10 to-card p-6 shadow-card">
      <p className="text-xs font-semibold uppercase tracking-wider text-accent-foreground/70">
        {label}
      </p>
      <h3 className="mt-2 text-xl font-semibold">{title}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      <a
        href={url}
        target="_blank"
        rel={block?.is_affiliate || block?.is_sponsored ? "sponsored nofollow noopener" : "noopener noreferrer"}
        className="mt-4 inline-flex items-center gap-2 rounded-lg bg-foreground px-4 py-2 text-sm font-medium text-background transition-smooth hover:bg-foreground/90"
      >
        {buttonText} <ArrowRight className="h-4 w-4" />
      </a>
    </div>
  );
};
